import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    allImprestSurrender,
  imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import {
    AllImprestSurrenderColumns,
  LeaveApplicationsColumns,
  imprestApplicationsColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import ImprestSurrenderForm from "./form";

const base_url = HRService.uri;
const actions = {
  entity: "Imprest Surrender",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  ViewSurrenderLineByApplication: {
    key: "surenderLine",
    button_name: "View Surrender Line",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

  submit: {
    key: "MARK_TASK_DONE",
    button_name: "Submit",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    inputObjectName: "submitImprest",
    inputSubobjectName: "imprestSurrender",
  },

  showStatus: true,
};
function ImprestSurrenderTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Imprest Surrender"
          subtitle="View all imprest Surrenders, create or Edit"
          columns={AllImprestSurrenderColumns}
          FormComponent={ImprestSurrenderForm}
          query={allImprestSurrender}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default ImprestSurrenderTable;
